/**
 * 🧾 Rent Invoice Reminder Message
 * @param {Object} invoice
 * @param {Object} userDetails
 * @returns {string} WhatsApp message text
 */
export const rentInvoiceReminderMessage = (invoice, userDetails) => {
  const monthName = new Date(invoice.invoice_date).toLocaleString("en-US", {
    month: "long",
  });
  const year = new Date(invoice.invoice_date).getFullYear();

  const backendUrl = import.meta.env.VITE_BACKEND_URL;

  const ownerName =
    `${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`.trim() ||
    "Owner";
  const businessName = userDetails?.company || "Your Business Name";
  const businessAddress =
    userDetails?.address || "Business Address, City, State";
  const ownerContact = userDetails?.contact || "Contact Number";

  const tenantName =
    `${invoice?.tenant_first_name || ""} ${invoice?.tenant_last_name || ""}`.trim() ||
    "Tenant";
  return `
Hello ${tenantName},

Hope you're doing well.

This is a gentle reminder that your rent invoice for *${monthName}, ${year}* has been generated.
Kindly ensure the payment is made within 15 days of invoice issuance to prevent any late charges.

*Invoice Amount:* ₹${invoice.invoice_amount}

You can securely view or download your invoice here:  
${backendUrl}/invoice/${invoice.id}/pdf

If you've already made the payment, please ignore this message.

Warm regards,  
*${ownerName}*  
*${businessName}*  
*${businessAddress}*  
*${ownerContact}*

_Powered by Rently — your personal rental management software._  
*अब किरायेदारी हुई और भी आसान!*
`;
};

/**
 * Payment Received Thank You Message
 * (Example for future use)
 */
export const paymentReceivedMessage = (invoice, userDetails) => {
  const monthName = new Date(invoice.invoice_date).toLocaleString("en-US", {
    month: "long",
  });
  return `
Hello ${invoice.tenant_first_name},

Thank you for making your payment for *${monthName}*! 💸  
We’ve successfully received ₹${invoice.paid_amount} towards your rent.

Have a great day!
${userDetails?.company || "Your Business Name"}
`;
};

// Export all templates as a single object (easy to manage)
export const WHATSAPP_MESSAGES = {
  rentInvoiceReminder: rentInvoiceReminderMessage,
  paymentReceived: paymentReceivedMessage,
};
